<template>
  <!-- 侧边栏 -->
  <a-layout-sider v-model:collapsed="collapsed" :collapsedWidth="collapsedWidth" :trigger="null"
                  :width="expandWidth" class="admin-layout-sider" collapsible>
    <div class="admin-sider-menu">
     <div style="display: flex;justify-content: center;padding: 20px 0"  :style="{width:expandWidth+'px;'}">
       <a-radio-group v-model:value="dev.mode" @change="dev.changeMode">
         <a-radio-button value="information">项目模式</a-radio-button>
         <a-radio-button value="tag">标签模式</a-radio-button>
       </a-radio-group>
     </div>
      <keep-alive>
        <admin-modal-project key="information" v-if="dev.mode === 'information'"/>
        <admin-modal-tag key="tag" v-else/>
      </keep-alive>
    </div>
  </a-layout-sider>
</template>

<script setup>
/*
* @author 友人a丶
* 侧边栏菜单组件
* */
import initialize from "./initialize";
import AdminModalProject from "@/layouts/admin-sidebar/modal/admin-modal-project.vue";
import AdminModalTag from "@/layouts/admin-sidebar/tag/admin-modal-tag.vue";
import devStore from "@/stores/devStore";
let dev = devStore();
console.log(dev.mode)
let {
  collapsed,
  collapsedWidth,
  expandWidth,
} = initialize();



</script>


<style lang="scss" scoped>

.admin-layout-sider {
  position: fixed;
  top: $admin-header-height;
  left: 0;
  z-index: 9;
  height: 100%;


  :deep(.ant-layout-sider-children) {
    display: flex;
    flex-direction: column;
    overflow: hidden;

    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;

    height: calc(100vh - $admin-header-height);

    background: $admin-sider-bg;
    box-shadow: $admin-sider-shadow;


    .admin-sider-menu {
      width: 100%;
      height: 100%;
      overflow: auto;
      padding-top: 15px;

      /*预留滚动条位置，防止发生抖动*/
      overflow-y: scroll;
      overflow-x: hidden;

      /*导入公共的滚动条样式*/
      @include scroll-bar(3px, 3px);


      .ant-menu {
        background: transparent;
        color: $admin-menu-color;
        //margin-top: 15px;

        /* GPU加速动画 */
        -webkit-transform: translateZ(0);
        -moz-transform: translateZ(0);
        -ms-transform: translateZ(0);
        -o-transform: translateZ(0);
        transform: translateZ(0);

        .ant-menu-item {
          a {
            color: $admin-menu-color;
            font-size: $sidebar-menu-size;

            &:hover {
              color: $primary;
            }
          }
        }

        .ant-menu-inline .ant-menu-item:not(:last-child) {
          margin-bottom: 4px;
        }

        .ant-menu-item-selected {
          a {
            color: $primary;
          }
        }
      }

      .ant-menu-inline, .ant-menu-vertical {
        border-right: none;
      }
    }


    .collapsed {

      flex-shrink: 0;
      padding: 8px 16px;
      margin: 4px 0;
      border-top: 1px solid #f0f0f0;

      background: $admin-sider-bg;
      box-shadow: $admin-sider-shadow;

      cursor: pointer;

      &:hover {
        color: $primary-color;
      }
    }
  }
}
</style>
